import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import ConnectedImage from './ConnectedImage'

const copy = {
  heading: `Connect to the leading cloud data warehouses`,
  descriptions: (
    <>
      Sync Segment profiles to your cloud data warehouse of choice (
      <a href="https://segment.com/docs/connections/reverse-etl/">
        BigQuery, Databricks, Redshift, Snowflake, and more
      </a>
      ) within minutes.
    </>
  ),
}

export const Connected = () => {
  return (
    <SectionBase variant="2Col" reverse={true}>
      <Section.Copy alignSelf="center">
        <StyledCopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p">{copy.descriptions}</CopyText.Description>
        </StyledCopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ConnectedImage alt={`Illustration: ${copy.heading}`} />
      </Section.Contents>
    </SectionBase>
  )
}

const StyledCopyTextBase = styled(CopyTextBase)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
`

export default Connected
